<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white rounded-b-md">
      <!-- <div class="flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Claim Types</p>
      </div> -->

      <el-tabs type="border-card" class="p-2">
        <div class="flex justify-between items-center pl-0 ml-0">
          <div class="flex justify-between items-left py-2">
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="pageSizes"
              :page-index="pageIndex"
              :page-size="pageSize"
              layout="sizes"
              :total="currentTableData.length"
            >
            </el-pagination>

            <!-- search -->
            <input
              v-model="searchInput"
              type="search"
              placeholder="Start typing to search..."
              class="bg-gray-200 w-52 py-1 rounded-md"
            />
            <!-- search -->
          </div>
          <div class="flex flex-wrap justify-end w-full gap-3">
            <div
              @click="showCreateClaimType = true"
              class="bg-primary gap-1 flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
            >
              <svg
                id="Layer_1"
                height="20"
                viewBox="0 0 24 24"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                fill="#fff"
              >
                <path
                  d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
                />
              </svg>
              <p>Create</p>
            </div>
          </div>
        </div>

        <div class="px-2 pb-2">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
              <loader class="center-h-v" />
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="del_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ del_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="showLocCrSuccess"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="delete_success"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ delete_success }}
            </div>
          </transition>
          <div>
            <ve-table
              v-if="searchInput"
              :columns="columns"
              :table-data="filteredTableData"
              sort-order="asc"
            />

            <ve-table
              :columns="columns"
              :tableData="currentTableData"
              v-if="!searchInput.length"
            >
            </ve-table>

            <p
              v-if="searchInput.length && filteredTableData.length === 0"
              class="text-center py-3"
            >
              No results
            </p>

            <p
              v-if="tableData.length == 0 && !loading && !get_error"
              class="p-1 text-center text-sm w-full bg-gray-100"
            >
              No Claim Types found
            </p>
            <!-- Pagination -->
            <div class="table-pagination text-center mt-2">
              <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
              >
                <!-- :current-page.sync="currentPage4" -->
              </el-pagination>
            </div>
            <!-- Pagination -->
          </div>
          <transition name="fade">
            <div
              v-if="get_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ get_error }}
            </div>
          </transition>
        </div>
      </el-tabs>
    </div>
    <!-- create -->
    <CreateClaimType
      @close="handleClose"
      :showCreateClaimType="showCreateClaimType"
      @closeOnSuccess="handleCloseOnSuccess"
    ></CreateClaimType>

    <!-- edit -->
    <EditClaimType
      @close="handleClose"
      :claimTypeToEdit="claimTypeToEdit"
      :info="info"
      :showEditClaimType="showEditClaimType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditClaimType>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from "axios";
import CreateClaimType from "@/components/CompanySetups/claimTypes/create.vue";
import EditClaimType from "@/components/CompanySetups/claimTypes/editClaimType.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";

export default {
  name: "claimTypeList",
  components: { Loader, CreateClaimType, EditClaimType, ActionWarning },
  data() {
    return {
      showCreateClaimType: false,
      showEditClaimType: false,
      loading: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      delete_success: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      claimTypeToDelete: null,
      showWarning: false,
      claimTypeToEdit: {},
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "a",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Description",
          key: "description",
          title: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Claim workflow for " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getClaimTypes();
    this.setPageSizes();
  },
  methods: {
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateClaimType = false;
      this.showEditClaimType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateClaimType = false;
      this.showLocCrSuccess = false;
      this.showEditClaimType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getClaimTypes();
    },

    reload() {
      this.getDepartments();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteClaimType(this.claimTypeToDelete);
    },

    handleEditButtonClick(claimType) {
      // Handle the button click for the edit button
      //console.log(claimType);

      this.claimTypeToEdit = {
        ClaimTypeId: claimType.Id,
        Name: claimType.Name,
        Description: claimType.Description,
      };
      this.showEditClaimType = true;
    },
    handleDeleteButtonClick(claimType) {
      // Handle the button click for the delete button
      //console.log(claimType)
      this.title = `Delete ${claimType.Name}`;
      this.message = `You are about to delete ${claimType.Name}!`;
      this.claimTypeToDelete = claimType;
      this.showWarning = true;
    },

    handleDeleteOnSuccess(message) {
      this.delete_success = message;
      setTimeout(() => {
        this.delete_success = null;
      }, 3000);
      this.getClaimTypes();
    },
    // /{organization}/setup/claim/type/v1/request
    getClaimTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/claim/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
              //console.log(this.tableData)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/claim/type/{claimTypeId}/v1/delete
    deleteClaimType(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/claim/type/${row.Id}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess(response.data.StatusMessage);
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },

    editClaimType(row) {
      this.showEditClaimType = true;
      this.info = row;
    },

    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "leavetypes.xlsx");
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
